define('boxes/helpers/message-popup',['jquery'], function($) {
    'use strict';

    function setupConfirmCallback(callbacks, $popup, doNotAutoClose) {
        if (callbacks === undefined || callbacks.confirmButtonCallback === undefined) {
            return;
        }
        var $firstButton = $popup.find('.confirm');
        $firstButton.show();
        $firstButton.on('click', function(e){
            e.preventDefault();
            callbacks.confirmButtonCallback(e);
			if(!doNotAutoClose)
            	$popup.remove();
        });
    }

    function setupCloseCallback(callbacks, $popup) {
        var $closeButton = $popup.find('.exit');
        if (callbacks === undefined || callbacks.closeButtonCallback === undefined) {
            $closeButton.click(function(e) {
                e.preventDefault();
                $popup.remove();
            });
        } else {
            $closeButton.on('click', function(e){
                e.preventDefault();
                callbacks.closeButtonCallback(e);
                $popup.remove();
            });
        }
    }

    function show($element, templateName, data, callbacks, doNotAutoClose) {
        $('.cnt-overlay', parent.document.body).applyTemplate(data, {
            template: templateName,
            into: $element,
            replace: false,
            addBefore: true
        });

        var $popup = $element.find('.overlay');
        setupConfirmCallback(callbacks, $popup, doNotAutoClose);
        setupCloseCallback(callbacks, $popup);
        return $popup;
    }


    var messagePopup = {};
    messagePopup.show = show;
    return messagePopup;
});

